import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/auth";
import { healthCheck } from "@/api/endpoints";
import { ApiError } from "@/api/client";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const login = useAuthStore((s) => s.login);
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: { pathname?: string } })?.from?.pathname ?? "/";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    // 一旦ストアに保存して、認証付きで簡易リクエスト (whoami) を叩く
    login(username, password);
    try {
      // /api/whoami は認証必須エンドポイント
      const resp = await fetch("/api/whoami", {
        headers: {
          Authorization:
            "Basic " + btoa(unescape(encodeURIComponent(`${username}:${password}`))),
        },
      });
      if (!resp.ok) {
        useAuthStore.getState().logout();
        throw new ApiError(
          resp.status,
          "unauthorized",
          "ユーザー名またはパスワードが正しくありません",
        );
      }
      navigate(from, { replace: true });
    } catch (err) {
      if (err instanceof ApiError) {
        setError(err.message);
      } else {
        setError("ネットワークエラーが発生しました");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full max-w-md">
        <div className="card">
          <h1 className="text-2xl font-bold text-brand-primary mb-2">
            Wonect Picking System
          </h1>
          <p className="text-sm text-gray-500 mb-6">サインインしてください</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label" htmlFor="username">
                ユーザー名
              </label>
              <input
                id="username"
                className="input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoComplete="username"
              />
            </div>
            <div>
              <label className="label" htmlFor="password">
                パスワード
              </label>
              <input
                id="password"
                type="password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-3">
                {error}
              </div>
            )}

            <button type="submit" className="btn-primary w-full" disabled={loading}>
              {loading ? "確認中…" : "ログイン"}
            </button>
          </form>
        </div>
        <p className="text-center text-xs text-gray-500 mt-4">
          .env.dev の BASIC_AUTH_USERNAME / BASIC_AUTH_PASSWORD でログインします
        </p>
      </div>
    </div>
  );
}
